var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('Header',{attrs:{"moudle":'report'}}),_c('div',{staticClass:"content-one flex-spa-bet"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }